import React, { useContext, useEffect, useState } from "react";
import Winner from "../../Assets/Images/Souvenir/fundo-floral-preto-png-2.png";
import axios from "axios";
import { Markup } from "interweave";
import { useParams } from "react-router-dom";
import RightSideAuctionWithoutTime from "../../components/StarShowcase/Auction/Content/RightSideAuction/RightSideAuctionWithoutTime";
import Navigation from "../../components/Layouts/Header/Navigation";
import { serverInfo } from "../../App";

import ContentLoader from "../../Screen/ContentLoader";

const WinnerCR7 = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const params = useParams();
  const [auctionInfo, setAuctionInfo] = useState([]);
  const [auctionApply, setAuctionApply] = useState([]);
  const [topBidder, setTopBidder] = useState([]);
  const [winner, setWinner] = useState([]);
  // const [userInfo , setUserInfo] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [sideData, setSideData] = useState([]);

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    axios.get(`/api/user/auctionApply/auction/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setAuctionInfo(res.data.auctionInfo);
        setAuctionApply(res.data.auctionApply);
        setTopBidder(res.data.topBidder);
        setWinner(res.data.winner);
      }
      setLoader(false);
    });
    axios.get(`/api/user/getStarAuctionProduct/${params.id}`).then((res) => {
      if (res.data.status === 200) {
        setSideData(res.data.product);
        // setUserInfo(res.data.userInfo);
      }
      setLoader(false);
    });
  }, []);

  return (
    <>
      <Navigation />
      {loader ? (
        <ContentLoader />
      ) : (
        <div className="container mt-3">
          <img
            src={imageCdnUrl + auctionInfo?.banner}
            className="img-fluid w-100 CR7Cover"
            alt=""
            style={{ height: "500px" }}
          />

          <div className="row justify-content-between">
            <div className="col-md-7">
              <h3 className="fw-bolder text-white mt-4">
                {auctionInfo?.title}
              </h3>

              <p className="text-white PText">
                {showMore ? (
                  <Markup content={auctionInfo?.details} />
                ) : (
                  <Markup content={auctionInfo?.details?.substring(0, 200)} />
                )}
                <button
                  className="btn text-white PText"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Show less" : "Show more"}
                </button>
              </p>

              <div className="mb-3 WinnerBg">
                <div className="btn WinnerCr fw-bold">
                  {winner?.win_status == 1
                    ? "Winner"
                    : "Best Of Luck for Next Time"}
                </div>

                <img src={Winner} alt={Winner} className="WinnerImg " />
                <div className="WinnerBack"></div>
                {topBidder?.user?.image ? (
                  <img
                    src={imageCdnUrl + topBidder?.user?.image}
                    alt=""
                    className="CR7user img-fluid"
                  />
                ) : (
                  <img
                    src={imageCdnUrl + topBidder?.user?.image}
                    alt=""
                    className="CR7user img-fluid"
                  />
                )}

                {/* <h3 className="WinnerName btn text-light fw-bold">Apurbo Roy</h3> */}
                <div className=" textWinner fw-bold">
                  {topBidder?.user?.first_name} {topBidder?.user?.last_name}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              {sideData &&
                sideData?.map((product) => (
                  <RightSideAuctionWithoutTime data={product} />
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WinnerCR7;
